import { Alert, Box, Column, Divider, Heading, Row, Text } from '@amzn/meridian';
import { FlavorContentEditor } from '../FlavorContentEditor';
import { FlavorLanguageSelector } from './FlavorLanguageSelector';
import { FlavorNameEditor } from './FlavorNameEditor';
import { GlobalContentEditor } from './GlobalContentEditor';
import { useMultiCreativeCampaignContent } from './useMultiCreativeCampaignContent';
import { useUpdateFlavorNames } from './useUpdateFlavorNames';

export const MultiCreativeCampaignContent = () => {
  useUpdateFlavorNames();
  const { handleChangeLanguageOption, languageSelectOptions, error, selectedFlavorsInfo, selectedLanguageOptionValue } =
    useMultiCreativeCampaignContent();

  return (
    <Box backgroundColor="primary" className="mt-3" id="content-editor" type="outline">
      <Row
        alignmentVertical="center"
        spacingInset="400 300 400 400"
        widths={[
          'fill',
        ]}
      >
        <Heading level={2}>Content configuration</Heading>
      </Row>

      {!!error && (
        <Row
          spacingInset="none 300 300"
          widths={[
            'fill',
          ]}
        >
          <Alert size="medium" type="error">
            {error}
          </Alert>
        </Row>
      )}
      <GlobalContentEditor />
      <Divider />

      {!selectedFlavorsInfo.length && (
        <Box spacingInset="400 400">
          <Text color="error">No languages or platforms selected</Text>
        </Box>
      )}

      <Box>
        {selectedFlavorsInfo.map((flavorInfo, orderingIndex) => (
          <Column key={`flavor-name-and-content-editor-container-${flavorInfo.key}`} spacingInset="400 400">
            <Row
              alignmentVertical="center"
              widths={[
                'fill',
                'fit',
              ]}
            >
              <Heading level={3}>{flavorInfo.headerText}</Heading>
              {orderingIndex === 0 && (
                <FlavorLanguageSelector
                  languageSelectOptions={languageSelectOptions}
                  onSelectLanguageOption={handleChangeLanguageOption}
                  selectedLanguageOptionValue={selectedLanguageOptionValue}
                />
              )}
            </Row>
            <FlavorNameEditor flavorIndex={flavorInfo.originalIndex} key={`flavor-name-editor-${flavorInfo.key}`} />
            <FlavorContentEditor key={`flavor-content-editor-${flavorInfo.originalIndex}`} name={`flavors[${flavorInfo.originalIndex}]`} />
            {selectedFlavorsInfo.length > 1 && orderingIndex !== selectedFlavorsInfo.length - 1 && <Divider size="medium" />}
          </Column>
        ))}
      </Box>
    </Box>
  );
};
